<template>
    <div class="auth-user">
        <v-dialog v-model="showForm" scrollable max-width="600">
            <v-card>
                <v-toolbar card prominent color="primary" dark>
                    <v-toolbar-title class="body-2">Perfil del usuario "{{detailsItem.username}}"</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancelForm()">
                        <v-icon medium>fa-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-flex d-flex text-xs-center>
                    <v-card-text v-if="!editUser">
                        <h4 class="headline mb-2">
                            {{ detailsItem.first_name + ' ' + detailsItem.last_name}}
                        </h4>
                        <div class="blue--text subheading font-weight-bold mb-2">{{ detailsItem.username}}</div>
                        <div class="blue--text">{{ detailsItem.email }} </div>
                    </v-card-text>
                    <template v-if="editUser">
                        <v-form ref="userForm" v-model="validUser">
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex xs5>
                                        <v-text-field
                                                v-model="userItem.first_name"
                                                label="Nombre">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs7>
                                        <v-text-field
                                                v-model="userItem.last_name"
                                                label="Apellidos">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="userItem.email"
                                                label="Email*"
                                                @keydown="userEmailErrors = []"
                                                :rules="userEmailRules"
                                                :error-messages="userEmailErrors">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </template>
                </v-flex>

                <v-flex>
                    <v-card-text class="py-0 pl-0 text-xs-right">
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        flat
                                        icon
                                        color="orange"
                                        :disabled="disableSaveButton"
                                        @click="editarUsuario">
                                    <v-icon v-on="on">{{getEditData().icon}}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{getEditData().label}}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        flat
                                        icon
                                        color="success"
                                        @click="saveForm()"
                                        :disabled="disableSaveButton"
                                        :loading="loading"
                                        v-if="editUser">
                                    <v-icon v-on="on">fa-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Salvar datos</span>
                        </v-tooltip>

                    </v-card-text>
                </v-flex>

                <v-divider class="mx-5"></v-divider>

                <v-layout tag="v-card-text" text-xs-left wrap>
                    <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Creado:</v-flex>
                    <v-flex xs5>{{ detailsItem.created_at }}</v-flex>
                    <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Actualizado:</v-flex>
                    <v-flex xs5>{{ detailsItem.updated_at }}</v-flex>
                    <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Ultimo loggeo:</v-flex>
                    <v-flex xs5>{{ detailsItem.last_login ? detailsItem.last_login : 'No se ha loggeado' }}</v-flex>
                </v-layout>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            :disabled="loading"
                            flat
                            round
                            small
                            outline
                            color="orange"
                            class="white--text"
                            @click="showPasswordChange = true">
                        Cambiar contraseña
                    </v-btn>
                    <v-btn color="success" flat :disabled="disableSaveButton" @click="cancelForm()">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <password-change
                v-if="showPasswordChange"
                @passwordChangeCanceled="showPasswordChange = false">
        </password-change>
    </div>
</template>

<script>
	import PasswordChange from "../password-change/password-change"
	export default {
		components: { PasswordChange },
		props: {
			detailsItem: Object
		},

		data: () => ({
            editUser: false,
            loading: false,

            //formulario de usuario
            userItem: {
				first_name: null,
				last_name: null,
				email: null,
			},
			validUser: true,
			userEmailRules: [
				v => !!v || "Debe proporcionar un correo.",
				// eslint-disable-next-line no-useless-escape
				v => /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(v) || 'Debe proporcionar un email válido '
			],
			userEmailErrors: [],

            //formulario de cambio de contrasena
			showPasswordChange: false
		}),

		computed: {
			showForm: {
				get: function() {
					return !this.$vuetify.breakpoint.smAndDown
				},
				set: function () {
					return this.cancelForm()
				}
			},
			disableSaveButton() {
				return this.loading || (!this.validUser)
			}
		},

		methods: {
			cancelForm() {
				this.$emit("detailsCanceled")
			},

			getFormatedTime(time) {
				let months_arr = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']

				let date = new Date(time * 1000)

				// Year
				let year = date.getFullYear()

				// Month
				let month = months_arr[date.getMonth()]

				// Day
				let day = date.getDay()

				// Hours
				let hours = date.getHours()

				// Minutes
				let minutes = "0" + date.getMinutes()

				// Seconds
				let seconds = "0" + date.getSeconds()

				return day+'-'+month+'-'+year+' '+hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)
			},

            editarUsuario() {
			    this.editUser = ! this.editUser
                if (this.editUser) {
                	this.userItem.first_name = this.detailsItem.first_name
                	this.userItem.last_name = this.detailsItem.last_name
                	this.userItem.email = this.detailsItem.email
                }
            },

			saveForm() {
				this.loading = true
				this.$refs.userForm.validate()
				if (this.validUser) {
					let user = {
						first_name: this.userItem.first_name,
						last_name: this.userItem.last_name,
						email: this.userItem.email
					}
					this.$store.dispatch("UPDATE_AUTH_USER", user).then(
						result => {
							if (!result){
								this.editUser = false
                            }
							else {
								if (result === null || result.status === 404) {
									//cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
									this.editUser = false
								} else {
									// El backend devolvió error de validación, pasando los errores a los campos correspondientes
									let { data, status } = result
									if (status === 422) {
										data.forEach(error => {
											if (error.field === "email") {
												this.userEmailErrors.push(error.message)
											}
										})
									}
								}
                            }
							this.loading = false
						}
					)
				} else {
					this.loading = false
				}
			},

            getEditData() {
				return this.editUser ? {icon: 'fa-close', label: 'Cancelar'} : {icon: 'fa-edit', label: 'Editar datos'}
            }
		},
	}
</script>

<style scoped>

</style>